import React from 'react';
import { useData } from '../context/DataContext';
import Loading from '../components/Loading';
import { Link } from 'react-router-dom';
import './styles/PortfolioPage.css';

const Portfolio = () => {
  const { data, loading, error } = useData();

  if (loading) return <Loading />;
  if (error) return <div>Error loading data</div>;

  const portfolioData = data.portfolio || [];
  console.log('Raw portfolioData:', portfolioData);

  // Extract header and description from earlier rows
  const header = portfolioData.find(row => row[0] === 'Header')?.[1] || 'My Portfolio';
  const description = portfolioData.find(row => row[0] === 'Description')?.[1] || 'Welcome to my portfolio!';

  // Find the row index of the project header row ("Project Name", "Brief description")
  const projectHeaderRowIndex = portfolioData.findIndex(row => row[0] === 'Project Name' && row[1] === 'Brief description');
  console.log('projectHeaderRowIndex:', projectHeaderRowIndex);

  // Extract projects from rows following the header row
  const projects = [];
  for (let i = projectHeaderRowIndex + 1; i < portfolioData.length; i++) {
    const row = portfolioData[i];
    if (!row[0] || row[0].trim() === '') break;
    projects.push({
      name: row[0],
      brief: row[1],
      full: row[2],
      github: row[3],
      writeup: row[4],
    });
  }
  console.log('Extracted projects:', projects);

  return (
    <main className="portfolio-page">
      <section className="intro">
        <h1>{header}</h1>
        <p>{description}</p>
      </section>
      <section className="portfolio-grid">
        {projects.map((project, index) => (
          <Link
            key={index}
            to="/portfolio/project"
            state={project}
            className="project-card-link"
          >
            <div className="project-card">
              <strong>{project.name}</strong>
              <span>{project.brief}</span>
            </div>
          </Link>
        ))}
      </section>
    </main>
  );
};

export default Portfolio;